export default (
    mainHidableElement,
    errorHidableElement,
    errorCodeContainerElement
  ) =>
  (errorCode) => {
    mainHidableElement.hide();
    errorHidableElement.show();
    errorCodeContainerElement.print(errorCode);
  };
